/**
 * The viewer's IANA zone; a report route cuts days by it, change by change
 * (#1235, #866). `undefined` where the browser does not name one.
 */
export function viewerTimeZone(): string | undefined {
  try {
    // The zone does not depend on the locale; one is named only because a
    // locale-less formatter is how dates end up in the browser's language.
    return new Intl.DateTimeFormat('en').resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}
